import { Badge } from '@/components/ui/badge';

export type Status =
  // Membership status
  | 'active'
  | 'completed'
  | 'closed'
  // Payment status
  | 'paid'
  | 'unpaid'
  | 'no_dues'
  // Member status
  | 'alive'
  | 'deceased'
  // Payment type
  | 'cash'
  | 'online';

const STATUS_LABEL: Record<Status, string> = {
  active: 'Active',
  completed: 'Completed',
  closed: 'Closed',
  paid: 'Paid',
  unpaid: 'Unpaid',
  no_dues: 'No dues',
  alive: 'Alive',
  deceased: 'Deceased',
  cash: 'Cash',
  online: 'Online',
};

const STATUS_CLASS: Record<Status, string> = {
  active: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  completed: 'border-[#4369a0]/35 bg-[#eef3f9] text-[#2d4f73]',
  closed: 'border-gray-300 bg-gray-100 text-gray-700',
  paid: 'border-teal-200 bg-teal-50 text-teal-900',
  unpaid: 'border-amber-200 bg-amber-50 text-amber-900',
  no_dues: 'border-teal-200 bg-teal-50 text-teal-800',
  alive: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  deceased: 'border-gray-300 bg-gray-100 text-gray-700',
  cash: 'border-teal-200 bg-teal-50 text-teal-800',
  online: 'border-[#4369a0]/35 bg-[#eef3f9] text-[#2d4f73]',
};

export const getStatusLabel = (status: Status): string => STATUS_LABEL[status];

export function StatusBadge({ status }: { status: Status }) {
  return (
    <Badge
      variant="outline"
      className={`${STATUS_CLASS[status]} h-6 rounded-md px-2 text-[11px] font-medium shadow-none`}
    >
      {STATUS_LABEL[status]}
    </Badge>
  );
}
